import { cn, Typography } from "@kyan/ui";
import React from "react";
import { formatUnits } from "viem";

import { BungeeQuoteResponse } from "#/services/bridge/bridge.types";

import { QuoteCard } from "../QuoteCard/QuoteCard";

interface QuoteInfoProps {
  quote: BungeeQuoteResponse["result"];
  className?: string;
}

export const QuoteInfo: React.FC<QuoteInfoProps> = ({ quote, className }) => {
  const output = quote.autoRoute?.output;
  const input = quote.input;

  return (
    <div className={cn("flex w-full flex-col items-center", className)}>
      <div className="mt-3 mb-2 w-full">
        <QuoteCard input={input} output={output} />
      </div>
      {quote?.autoRoute?.refuel?.output && (
        <Typography
          xs
          className={cn("flex w-full items-center justify-between", className)}
        >
          Gas fee
          <Typography primary>
            ${formatUnits(BigInt(quote?.autoRoute?.refuel?.output), 18)}
          </Typography>
        </Typography>
      )}
      {quote?.autoRoute && (
        <div className="mt-1 flex w-full items-center justify-between">
          <Typography xs>Expected conversion time</Typography>
          <Typography xs primary>
            {quote?.autoRoute.estimatedTime}s
          </Typography>
        </div>
      )}
    </div>
  );
};
